(ns practitest.frontend.xbot.agents-view.av-buttons
  (:require
    [re-frame.core :as re-frame]
    [reagent.core :as r]
    ["react-modal" :as ReactModal]
    [practitest.frontend.xbot.events :as events]
    [practitest.frontend.common.ui :as ui]
    [practitest.frontend.components.icons :as icons]))

(defn close-modal-btn [state title]
  [:button.btn.btn-default.x-btn-in-modal
   {:on-click #(swap! state assoc-in [:popup :open?] false)}
   title])

(defn action-modal-btn [{:keys [state title on-click]}]
  [:button.btn.btn-default.x-btn-in-modal.blue-bg.pull-right
   {:on-click (fn [_]
                (re-frame/dispatch on-click)
                (swap! state assoc-in [:popup :open?] false))}
   title])

(defn cancel-disable-agent-modal [state]
  (let [popup-state (:popup @state)]
    [:>
     ReactModal
     (ui/modal-settings state popup-state)
     (r/as-element
      [:div.x-text-in-modal
       [:h5 "This will cancel the running test and disable the agent"]
       [:p.padding-bottom-10
        {:style {:color "grey"}}
        "Agent can be enabled again later"]
       [:div.button-group
        [:div
         [close-modal-btn state "Back"]
         [action-modal-btn
          {:state    state
           :title    "OK"
           :on-click [::events/kill-running-item
                      {:job-project-id     nil
                       :job-agent-id       (:agent-id popup-state)
                       :also-disable-agent true}]}]]]])]))

(defn remove-agent-modal [state]
  (let [popup-state (:popup @state)]
    [:>
     ReactModal
     (ui/modal-settings state popup-state)
     (r/as-element
      [:div.x-text-in-modal
       [:h5.padding-bottom-10
        "This will remove the agent"]
       [:div.button-group
        [:div
         [close-modal-btn state "Cancel"]
         [action-modal-btn
          {:state    state
           :title    "Remove"
           :on-click [::events/remove-agent {:agent-id (:agent-id popup-state)}]}]]]])]))

(defn cancel-disable-agent-btn [state-cancel-disable id]
  [:button.btn.blue-bg.agent-cancel-disable-btn
   {:on-click (fn [_]
                (swap! state-cancel-disable update :popup
                       (fn [popup-state]
                         (assoc popup-state
                                :open?    true
                                :agent-id id))))}
   [ui/icon "fa-times-circle"]
   " Cancel & Disable"])

(defn enable-disable-tooltip [enabled?]
  [:span
   [ui/info-tooltip-ui
    {:options {:placement "bottom"
               :class     "xbot fa fa-question-circle-o clickable"
               :id        "agents-view-enable-disable-q-mark"}}
    [:span.label.label-info "Info"]
    (if enabled?
      " Disabling the agent will keep it online but will prevent it from receiving new jobs"
      " Enabling the agent will allow it to receive new jobs")]])

(defn enable-disable-agent-btn [enabled? id]
  [:<>
   [enable-disable-tooltip enabled?]
   ui/nbsp
   [:button.btn.blue-bg.agent-enable-disable-btn
    {:onClick (fn [_]
                (let [open-tooltip (first (.getElementsByClassName js/document "popover fade bottom in"))]
                  (re-frame/dispatch [::events/toggle-enable-agent {:agent-id id :enabled? (not enabled?)}])
                  (when open-tooltip (.remove open-tooltip))))}
    (if enabled? "Disable" "Enable")
    " Agent"]])

(defn remove-agent-btn [state-remove id]
  [:button.btn.btn-default.agent-remove-btn
   {:style    {:line-height "1.85em"}
    :on-click (fn [_]
                (swap! state-remove update :popup
                       (fn [popup-state]
                         (assoc popup-state
                                :open?    true
                                :agent-id id))))}
   [ui/icon "fa-trash"]
   " Remove Agent"])

(defn display-disable-remove-btns [{:keys [online? busy? enabled? remove-btn-trigger]} id]
  (let [state-cancel-disable  (r/atom {:popup {:open? false}})
        state-remove          (r/atom {:popup {:open? false}})]
    (fn [{:keys [online? busy? enabled? remove-btn-trigger]} id]
      [:<>
       [cancel-disable-agent-modal state-cancel-disable]
       [remove-agent-modal state-remove]
       [:div.pull-right
        {:style {:padding-right "15px"}}
        (if busy?
          [cancel-disable-agent-btn state-cancel-disable id]
          (if online?
            [enable-disable-agent-btn enabled? id]
            (when remove-btn-trigger
              [remove-agent-btn state-remove id])))]])))
